module.exports = __webpack_public_path__ + "static/media/toggle_down.8dfb8809.svg";